module.exports = __webpack_public_path__ + "img/caro2.82ab127f.png";